import "./App.css";
import Aviator from "./components/aviator";
import SVGs from "./components/svgs";
import AviatorProvider from "./store/aviator";
import SocketProvider from "./providers/SocketProvider";
import { ReduxProvider } from "./providers/ReduxProvider";
import SocketReduxConnector from "./components/SocketReduxConnector";
import AuthWrapper from "./components/AuthWrapper/AuthWrapper";

import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
      <SVGs />
      <ReduxProvider>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <AuthWrapper>
            <SocketProvider>
              <SocketReduxConnector />
              <AviatorProvider>
                <Routes>
                  {/* Auth route with token and optional currency */}
                  {/* Formats supported (event-1 is Aviator, event-6 is Plinko):
                      /auth/event-1/token
                      /auth/event-1/token?currency=PKR
                      /auth/event-1/token/PKR
                      /auth/event-1/token/currency=PKR
                  */}
                  <Route path="/auth/event-:eventId/:token" element={<Aviator />} />
                  <Route path="/auth/event-:eventId/:token/:currency" element={<Aviator />} />
                  <Route path="/auth/*" element={<Aviator />} />
                  <Route path="/" element={<Aviator />} />
                </Routes>
              </AviatorProvider>
            </SocketProvider>
          </AuthWrapper>
        </BrowserRouter>
      </ReduxProvider>
    </>
  );
}

export default App;
